import React, { useEffect, useState } from "react";
import { Capacitor } from "@capacitor/core";
import { FirebaseAnalytics } from "@capacitor-firebase/analytics";
import { useAuth } from "../../context/AuthContext";
import { setAnalyticsConsent } from "../../data/accountRepo";
import { useUserData } from "../../context/UserDataContext";
import AnalyticsConsentSheet from "./AnalyticsConsentSheet";

export default function AnalyticsConsentGate() {
  const { user } = useAuth();
  const { userData, loading } = useUserData();

  // null = we haven't decided whether to show anything yet
  const [open, setOpen] = useState(null);

  // (optional but recommended) disable by default until we know


  useEffect(() => {
    // ✅ web: do nothing + never show modal
    if (!Capacitor.isNativePlatform()) {
        setOpen(false);
        return;
      }
  
    if (!user?.uid) return;
    if (loading) return;

    // If your context can ever have "no userData yet" even when loading is false,
    // guard for that too:
    if (!userData) return;

    const decision = userData?.consents?.analytics?.enabled;

    if (decision === true) {
      FirebaseAnalytics.setCollectionEnabled({ enabled: true });
      setOpen(false);
      return;
    }

    if (decision === false) {
      FirebaseAnalytics.setCollectionEnabled({ enabled: false });
      setOpen(false);
      return;
    }

    if (!navigator.onLine) {
      // Will re-evaluate automatically when userData updates after reconnect
      return;
    }
    
    // Only open once we're sure userData is loaded and decision is truly missing
    setOpen(true);
  }, [user?.uid, loading, userData]);

  const accept = async () => {
    await setAnalyticsConsent({ uid: user.uid, enabled: true });
    await FirebaseAnalytics.setCollectionEnabled({ enabled: true });
    await FirebaseAnalytics.logEvent({ name: "analytics_consent_granted" });
    setOpen(false);
  };

  const decline = async () => {
    await setAnalyticsConsent({ uid: user.uid, enabled: false });
    await FirebaseAnalytics.setCollectionEnabled({ enabled: false });
    setOpen(false);
  };

  // Don't render anything until we know whether we should show it
  if (open === null) return null;

  return (
    <AnalyticsConsentSheet
      open={open}
      onAccept={accept}
      onDecline={decline}
    />
  );
}
